<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Lista ukupnog vremena/prekovremeno</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Sektor -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label no-print">Sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="seletedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  getShortTimeFromTicks,
  maskIfEquealsValue,
  getDateFromTicks,
} from "../../_helpers/arrangers";
//import //   getDateFromTicks,
//   maskIfEquealsValue,
//   isWorkingDayFromDate,
//"../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#ffd6c0",
];

export default {
  name: "TotalTime",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      params: {
        data: [
          [
            "n",
            "Ime i prezime",
            "Radnih dana",
            "Radnih subota",
            "Radnih nedelja",
            "GO/BO/PO/TB",
            "Ukupan fond (h)",
            "Opravdano odsustno (h)",
            "Korigovani fond (h)",
            "Na poslu (h)",
            "Prekovremeno (h)",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 35 },
          { column: 2, width: 50 },
          { column: 3, width: 50 },
          { column: 4, width: 50 },
          { column: 5, width: 100 },
        ],
        wordWrap: "break-word",
        whiteSpace: "normal",
        highlight: { column: [-1] },
        highlightedColor: colors[6],
        // sort: [33],
      },
      departments: [],
      seletedDepartment: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
    this.getDepartments();
  },
  methods: {
    tableCellClicked() {},
    resetUi() {
      this.params.data = [
        [
          "n",
          "Ime i prezime",
          "Radnih dana",
          "Radnih subota",
          "Radnih nedelja",
          "GO/BO/PO/TB",
          "Ukupan fond (h)",
          "Opravdano odsustno (h)",
          "Korigovani fond (h)",
          "Na poslu (h)",
          "Prekovremeno (h)",
        ],
      ];
      this.dailyLogs = [];
    },
    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    getData(departmentId, month, year) {
      console.log("getData");
      ReportService.GetTotalTimeDataByDepartmentIdAndMonth(
        departmentId,
        month,
        year
      ).then((response) => {
        console.log(response.data);
        this.calculateData(response.data);
      });
    },
    calculateData(data) {
      // first add days array to employees
      this.employees.forEach((emp) => {
        emp.days = new Array(31).fill(0);
        emp.total = 0;
      });

      let ndx = 1;

      data.forEach((dlog) => {
        this.params.data.push([
          ndx++,
          dlog.name,
          dlog.workdaysInMonthCount,
          maskIfEquealsValue(dlog.saturdaysIWorkedCount, "0"),
          maskIfEquealsValue(dlog.sundaysIWorkedCount, "0"),
          dlog.goCount +
            "/" +
            dlog.boCount +
            "/" +
            dlog.poCount +
            "/" +
            dlog.tbCount,
          dlog.totalWorkhoursFund,
          dlog.justifiedAbsentWorkhours,
          dlog.correctedWorkhoursFund,
          maskIfEquealsValue(
            getShortTimeFromTicks(dlog.hoursISpentOnWork),
            "00:00"
          ),
          maskIfEquealsValue(getShortTimeFromTicks(dlog.overtime), "00:00"),
        ]);
      });
    },

    pushLastRow() {
      let ndx = 1;

      let totalValue = new Array(31).fill(0);

      this.employees.forEach((emp) => {
        totalValue[0] += emp.days[0];
        totalValue[1] += emp.days[1];

        this.params.data.push([
          ndx++,
          emp.firstName + " " + emp.lastName,
          maskIfEquealsValue(
            getShortTimeFromTicks(emp.hoursISpentOnWork),
            "00:00"
          ),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[1]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[2]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[3]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[4]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[5]), "00:00"),
          maskIfEquealsValue(getDateFromTicks(emp.total), "00:00:00"),
        ]);
      });

      this.params.data.push([
        "",
        "Σ (za cio mjesec)",
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[0]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[1]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[2]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[3]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[4]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[5]), "00:00"),
        maskIfEquealsValue(
          getDateFromTicks(
            totalValue.reduce((partialSum, a) => partialSum + a, 0)
          )
        ),
      ]);
    },
    departmentSelected() {
      this.resetUi();

      let departmentId = this.seletedDepartment.id;

      let allEmployees = this.departmentData.find((d) => {
        return d.departmentId === departmentId;
      }).employee;

      this.employees = [];
      allEmployees.forEach((emp) => {
        if (emp.status) {
          this.employees.push(emp);
        }
      });

      this.getData(departmentId, this.selectedMonth, this.selectedYear);
    },
  },
};
</script>

<style scoped>
.base-demo {
  /* width: 1080px; */
  white-space: nowrap;
}

.small {
  font-size: 12px;
}

.base-demo >>> .v-table-row.is-header {
  border-bottom: 1px solid red !important;
}
.base-demo >>> .table-cell {
  padding: 1px !important;
}
.base-demo >>> .table-cell-content {
  padding: 0px !important;
}
</style>
